export default "__VITE_ASSET__GZ0DVVov__"